import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccesosSesion } from '@shared/models/sesion/accesos';
import { StorageService } from 'core-tsi';

export const hasAccessModuleGuard = (module?:number): CanActivateFn => {
  return () => {
      if(module == null || module == undefined) return true;
      const router = inject(Router)
      const sesion = StorageService.getSession()
      const accessSesion = (sesion?.accesos || []) as AccesosSesion[]
      const hasAccess = accessSesion.some(acceso => acceso.codmod == module)
      return hasAccess ? true : router.createUrlTree(['/unauthorized']);
    };
};
